import { ReverseRows } from '@ahc-digital/component-library';
import { Field, LinkField, RichTextField } from '@sitecore-jss/sitecore-jss-nextjs';
import { PromptForMissingDatasource } from 'src/shared/PromptForMissingDatasource';
import { CreateReverseRowStoriesModel } from './C11ReverseRowStories.service';
import {
  AnchorTargetParams,
  DynamicPlaceholderParams,
  ImagePropertiesParams,
  RenderingProps,
  TranslationOptionsParams,
} from 'src/shared/shared.types';
import { translationClasses } from 'src/shared/TranslationClasses';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';

export type C11ReverseRowStoriesProps = RenderingProps<
  C11ReverseRowStoriesFields,
  C11ReverseRowStoriesRenderingParams
>;

export type C11ReverseRowStoriesFields = {
  Title?: Field<string>;
  TopSupportingCopy?: RichTextField;
  BottomSupportingCopy?: RichTextField;
  BottomCTA?: LinkField;
};

export type C11ReverseRowStoriesRenderingParams = {
  TitleType?: string;
  RemovePaddingBetweenRows?: boolean;
} & DynamicPlaceholderParams &
  TranslationOptionsParams &
  AnchorTargetParams &
  ImagePropertiesParams;

export const Default = (props?: C11ReverseRowStoriesProps): JSX.Element => {
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  if (!props?.rendering?.dataSource)
    return <PromptForMissingDatasource rendering={props?.rendering} />;
  return (
    <ReverseRows
      className={translationClasses(props?.params)}
      id={props?.params?.AnchorLinkTargetName}
      data-component={marketingRenderingName}
      {...CreateReverseRowStoriesModel(props)}
    />
  );
};
